import { actionWithDatapoint } from 'owa-analytics-actions';

import getEntryPoint from '../selectors/getEntryPoint';
import { getUserMailboxGuid } from '../utils/getMailboxGuid';

import type PublishingSettings from 'owa-service/lib/contract/PublishingSettings';
/**
 * Action to update the personal booking page publishing settings in the store.
 */

const updatePublishingSettings = actionWithDatapoint(
    'updatePublishingSettings',
    (publishingSettings: PublishingSettings) => ({
        publishingSettings,
    }),
    actionMessage => ({
        customData: {
            entryPoint: getEntryPoint(),
            isPublished: actionMessage.publishingSettings?.IsPublished,
            mailboxGuid: getUserMailboxGuid(),
        },
    })
);

/**
 * Action to update the personal booking page publishing settings IsPublished value in the store.
 */

export const updatePublishingSettingsIsPublished = actionWithDatapoint(
    'updatePublishingSettingsIsPublished',
    (isPublished: boolean) => ({
        isPublished,
    }),
    actionMessage => ({
        customData: {
            entryPoint: getEntryPoint(),
            isPublished: actionMessage.isPublished,
            mailboxGuid: getUserMailboxGuid(),
        },
    })
);

export default updatePublishingSettings;
